<template>
  <div class="teams-categories-page">
    <CitiesList title="Команды" :get-link="getLink" />
    <!-- <CitiesList title="Команды" :get-link="getLink" final-link="/teams/1" /> -->
  </div>
</template>

<script>
import CitiesList from "@/components/city/CitiesList";

export default {
  name: "TeamsCategoriesPage",
  components: {
    CitiesList
  },
  methods: {
    getLink(city) {
      if (!city) return;
      return { name: "teams-category", params: { slug: city.id } };
    }
  }
};
</script>
